import { render, staticRenderFns } from "./_ItemDialog.vue?vue&type=template&id=496eac04&scoped=true&"
import script from "./_ItemDialog.vue?vue&type=script&lang=js&"
export * from "./_ItemDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496eac04",
  null
  
)

export default component.exports